import React from 'react'
import DocumentTitle from 'react-document-title'
import { Route } from 'react-router-dom'
import { SuccessPage } from 'apps/detention-review/components/SuccessPage'
import { DetentionRequestForm } from './DetentionRequestForm'

export const DetentionRequest = () => {
  return (
    <DocumentTitle title='Detention Request'>
      <div>
        <Route exact path='/detention-request/:shipmentId'>
          <DetentionRequestForm />
        </Route>
        <Route exact path='/detention-request/:shipmentId/success'>
          <SuccessPage />
        </Route>
      </div>
    </DocumentTitle>
  )
}

export default DetentionRequest
